import './teaser-slider-element.scss';

import Swiper from 'swiper';
import { A11y, Navigation, Pagination, Keyboard } from 'swiper/modules';

class TeaserElementSlider {
    constructor ($element) {
        this.$teaserElement = $element;
        this.$teaserElementSlider = this.$teaserElement.querySelector('[data-teaser-element="slider"]');
        this.$slides = this.$teaserElementSlider.querySelectorAll('.swiper-slide');
        this.$prevButton = null;
        this.$nextButton = null;
        this.$pagination = null;
        this.slider = null;

        // minimum amount of slides to activate the slider on desktop (>= 1024px)
        // defaults to 5 (legacy behaviour); modules can lower it via data-slider-desktop-min
        this.desktopMin = parseInt(this.$teaserElement.dataset.sliderDesktopMin, 10) || 5;

        this.prevSlideMessage = window.TRANSLATIONS.SLIDER.PREV_SLIDE_MESSAGE;
        this.nextSlideMessage = window.TRANSLATIONS.SLIDER.NEXT_SLIDE_MESSAGE;
        this.firstSlideMessage = window.TRANSLATIONS.SLIDER.FIRST_SLIDE_MESSAGE;
        this.lastSlideMessage = window.TRANSLATIONS.SLIDER.LAST_SLIDE_MESSAGE;
        this.slideLabel = window.TRANSLATIONS.SLIDER.SLIDE_LABEL;
        this.slideLabelFrom = window.TRANSLATIONS.SLIDER.SLIDE_LABEL_FROM;

        this.initialize();
    }

    initialize () {
        if (this.$slides.length < 2) {
            return;
        }

        if (this.$slides.length >= this.desktopMin) {
            this.initSlider();

            return;
        }

        // fewer slides than the desktop threshold: slider only on smaller viewports
        this.checkSize();
        this.setEvents();
    }

    checkSize () {
        if (window.mediaMatchHandler[1024].matches) {
            this.destroySlider();
        } else {
            if (this.slider === null) {
                this.initSlider();
            }
        }
    }

    setEvents () {
        [1024, 768, 320].forEach((bp) => {
            window.mediaMatchHandler[bp].addEventListener('change', () => {
                this.checkSize();
            });
        });
    }

    initSlider () {
        this.$prevButton = this.$teaserElement.querySelector('[data-slider="prev"]');
        this.$nextButton = this.$teaserElement.querySelector('[data-slider="next"]');
        this.$pagination = this.$teaserElement.querySelector('[data-slider="pagination"]');

        this.slider = new Swiper(this.$teaserElementSlider, {
            modules: [A11y, Navigation, Pagination, Keyboard],
            slidesPerView: 'auto',
            lazyPreloadPrevNext: true,
            autoHeight: false,
            speed: 500,
            watchSlidesProgress: true,
            a11y: {
                prevSlideMessage: this.prevSlideMessage,
                nextSlideMessage: this.nextSlideMessage,
                firstSlideMessage: this.firstSlideMessage,
                lastSlideMessage: this.lastSlideMessage,
                slideLabelMessage: `${this.slideLabel} {{index}} ${this.slideLabelFrom} {{slidesLength}}`,
            },
            pagination: {
                el: this.$pagination,
                type: 'bullets',
                clickable: false
            },
            navigation: {
                nextEl: this.$nextButton,
                prevEl: this.$prevButton
            },
            keyboard: true,
        });
    }

    destroySlider () {
        if (this.slider !== null) {
            this.slider.destroy(true, true);
            this.slider = null;
        }
    }
}

export { TeaserElementSlider };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    const $$teaserElementSlider = $context.querySelectorAll('[data-teaser-element="root"]');

    if ($$teaserElementSlider.length > 0) {
        $$teaserElementSlider.forEach(($teaserElementSlider) => {
            const teaserElementSlider = new TeaserElementSlider($teaserElementSlider); // eslint-disable-line
        });
    }
});